import React from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';

interface ConfigurationStatusCardProps {
  isConfigured: boolean;
  printerUrl: string;
  uniqueId: string | null;
  onShowSettings: () => void;
}

export const ConfigurationStatusCard: React.FC<
  ConfigurationStatusCardProps
> = ({ isConfigured, printerUrl, uniqueId, onShowSettings }) => (
  <Row className="mb-4">
    <Col lg={8}>
      <Card>
        <Card.Header>
          <Card.Title className="mb-0">Status konfiguracji</Card.Title>
        </Card.Header>
        <Card.Body>
          <div className="mb-3">
            <strong>Status:</strong>{' '}
            <span
              className={`badge ${isConfigured ? 'bg-success' : 'bg-warning'}`}
            >
              {isConfigured ? 'Skonfigurowana' : 'Nie skonfigurowana'}
            </span>
          </div>
          {isConfigured && (
            <>
              <div className="mb-3">
                <strong>Adres API:</strong>
                <br />
                <code>{printerUrl}</code>
              </div>
              <div className="mb-3">
                <strong>Numer unikatowy:</strong>
                <br />
                <code>{uniqueId ?? '—'}</code>
              </div>
            </>
          )}
          <Button variant="primary" onClick={onShowSettings}>
            {isConfigured ? 'Zmień ustawienia' : 'Skonfiguruj drukarkę'}
          </Button>
        </Card.Body>
      </Card>
    </Col>
  </Row>
);
